class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.classList.remove("toggle-search"); //hide it whenever added
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search-result_container');
        this.closeButton = this.querySelector("#close-search");
        this.closeButton.addEventListener('click', this.hideSearchBar.bind(this));
        this.searchpagePredictiveReasults = false;
        if (this.closest('.search-header') != null && this.closest('.search-header') != undefined) {
            this.searchpagePredictiveReasults = true;
        }
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.renderSearchResults(searchTerm);
    }

    renderSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsHTML;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }
    hideSearchBar(e) {
        e.preventDefault();
        if (!this.searchpagePredictiveReasults) {
            this.input.value = '';
            this.predictiveSearchResults.style.visibility = "hidden";
        } else {
            this.predictiveSearchResults.style.visibility = "hidden";
            this.predictiveSearchResults.style.display = "none";
            this.closeButton.style.display = "none";
        }
    }
    open() {
        this.predictiveSearchResults.style.visibility = "visible";
        if (!this.searchpagePredictiveReasults) {
            this.closest('header').style.zIndex = "2";
        } else {
            this.closeButton.style.display = "inline-block";
            this.predictiveSearchResults.style.display = "block";
            
        }

    }

    close() {
        this.predictiveSearchResults.style.visibility = "hidden";
        if (!this.searchpagePredictiveReasults) {
            this.closest('header').style.zIndex = "auto";
        } else {
            this.closeButton.style.display = "none";
            this.predictiveSearchResults.style.display = "none";
        }
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
